import { c as _c } from "react/compiler-runtime";
import i18n from 'i18next';
import { Button, getFilePreviewUrl, openDialog, showNotification } from 'platform/components';
import { Link, Show } from 'platform/foundation';
import { HStack, VStack } from 'platform/foundation-tw';
import { MouseEvent } from 'react';
import { isNil } from 'ramda';
import { isArray } from 'ramda-adjunct';
import { openFile } from 'shared/web';
import { CellRendererProps } from '../../types/CellRendererProps';
import { getFileCellRendererIcon } from './utils/getFileCellRendererIcon';
type FileEntry = {
  id?: string;
  title?: string;
  remoteUrl?: string;
  contentType?: string;
};
type FileCellRendererProps = CellRendererProps<unknown>;
const handleOnClick = (event: MouseEvent, value: FileEntry) => {
  event.preventDefault();
  if (!value.remoteUrl) {
    showNotification.error();
    return;
  }
  const url = getFilePreviewUrl(value.remoteUrl);
  if (isNil(url)) {
    showNotification.error();
    return;
  }
  openFile(url);
};
export function FileCellRenderer(props) {
  const $ = _c(32);
  const cellValue = props.value as FileEntry | FileEntry[] | undefined;
  if (isArray(cellValue)) {
    const firstValue = cellValue?.[0];
    const t0 = cellValue?.length === 1;
    let t1;
    if ($[0] !== firstValue?.contentType) {
      t1 = firstValue?.contentType ? getFileCellRendererIcon(firstValue?.contentType) : undefined;
      $[0] = firstValue?.contentType;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = firstValue?.title;
    let t3;
    if ($[2] !== firstValue) {
      t3 = event => handleOnClick(event, firstValue);
      $[2] = firstValue;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
      t4 = <Link leftIcon={t1} title={t2} onClick={t3} size="small" download={true} />;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t0 || $[9] !== t4) {
      t5 = <Show when={t0}>{t4}</Show>;
      $[8] = t0;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const t6 = cellValue?.length > 1;
    let t7;
    if ($[11] !== cellValue?.length) {
      t7 = i18n.t("page.datagrid.labels.showFiles", {
        count: cellValue?.length ?? 0
      });
      $[11] = cellValue?.length;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== cellValue) {
      t8 = () => openDialog(<VStack spacing={2}>{cellValue?.map(_temp)}</VStack>, {
        title: i18n.t("page.datagrid.labels.allFiles"),
        size: "small"
      });
      $[13] = cellValue;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t7 || $[16] !== t8) {
      t9 = <Button variant="link" leftIcon="view" title={t7} onClick={t8} />;
      $[15] = t7;
      $[16] = t8;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== t6 || $[19] !== t9) {
      t10 = <Show when={t6}>{t9}</Show>;
      $[18] = t6;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t10 || $[22] !== t5) {
      t11 = <HStack align="center" spacing={2}>{t5}{t10}</HStack>;
      $[21] = t10;
      $[22] = t5;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    return t11;
  }
  const singleValue = cellValue as FileEntry | undefined;
  const t0 = singleValue?.title;
  let t1;
  if ($[24] !== singleValue?.contentType) {
    t1 = singleValue?.contentType ? getFileCellRendererIcon(singleValue?.contentType) : undefined;
    $[24] = singleValue?.contentType;
    $[25] = t1;
  } else {
    t1 = $[25];
  }
  let t2;
  if ($[26] !== singleValue) {
    t2 = event_1 => handleOnClick(event_1, singleValue ?? {});
    $[26] = singleValue;
    $[27] = t2;
  } else {
    t2 = $[27];
  }
  let t3;
  if ($[28] !== t0 || $[29] !== t1 || $[30] !== t2) {
    t3 = <Link title={t0} leftIcon={t1} onClick={t2} size="small" download={true} />;
    $[28] = t0;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  return t3;
}
function _temp(file, index) {
  return <Link title={file?.title} onClick={event_0 => handleOnClick(event_0, file)} leftIcon={file?.contentType ? getFileCellRendererIcon(file?.contentType) : undefined} size="small" key={file?.id ?? index} />;
}